import React from 'react';
import Contact from './Contact';
import Education from './Education';
import Footer from './Footer';
import Intro from './Intro';
import Navbar from './Navbar';
import Skills from './Skills';
import Work from './Work';



function Home() {
  return (
    <>
        
        <Navbar />
        <Intro />
        <Education />
        <Skills />
        <Work />
        <Contact />
        <Footer />
    </>
  )
}

export default Home;